import { pageTitle } from 'ember-page-title';
import { t } from 'ember-intl';
import { BreadcrumbsItem } from 'core/components';

import PageUsersInvite from 'hcp/components/page/users/invite';

<template>
  {{pageTitle (t "page-title.access-control.users.invite")}}

  <BreadcrumbsItem
    @icon="user"
    @route="cloud.access-control.users.invite"
    @text={{t "components.page.access-control.users.invite.title"}}
    data-test-access-control-users-invite-breadcrumb
  />

  {{! These components are for basic roles invites to the organization only. }}
  <PageUsersInvite
    @organization={{@controller.model.organization}}
    @currentRolesLocation={{@controller.model.currentRolesLocation}}
    @currentScopeLink={{@controller.model.currentScopeLink}}
  />
</template>
